import { render, staticRenderFns } from "./ShrimpSelector.vue?vue&type=template&id=0b619ad8&scoped=true&"
import script from "./ShrimpSelector.vue?vue&type=script&lang=js&"
export * from "./ShrimpSelector.vue?vue&type=script&lang=js&"
import style0 from "./ShrimpSelector.vue?vue&type=style&index=0&id=0b619ad8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b619ad8",
  null
  
)

export default component.exports